/** Shared Remitano <-> Aureus deposit-audit range caps (v4.8.270 / v4.8.277). */
export const REMITANO_AUDIT_DEFAULT_LIMIT = 2000
export const REMITANO_AUDIT_MAX_LIMIT = 2000
/** Aureus CPT pages to this cap. 2000 was newest-first, so conception looked like 2026-07-31. */
export const REMITANO_AUDIT_FULL_MAX = 20000
/** First hashed CPT on live is 2025-07-12. */
export const REMITANO_AUDIT_CONCEPTION_YMD = '2025-07-01'